module.exports = __webpack_public_path__ + "img/family_btn_download.f1ff738f.png";